

















import Vue, { PropType } from 'vue';
import { IconData, IconFamily } from '@/icons';
export default Vue.extend({
  props: {
    // One of iconData or name is required
    iconData: {
      type: Object as PropType<IconData>,
      required: false
    },
    // One of iconData or name is required
    name: {
      type: String,
      required: false
    },

    small: {
      type: Boolean,
      default: false
    },
    medium: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    white: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    iconClassName(): string {
      return 'mdi-' + this.iconData?.name;
    },

    useGoogleIcons(): boolean {
      return this.iconData?.family === IconFamily.GOOGLE_ICONS;
    },

    useCommunity(): boolean {
      return !this.useGoogleIcons;
    },

    iconSize(): string {
      if (this.small) {
        return 'small';
      }

      if (this.medium) {
        return 'medium';
      }

      if (this.large) {
        return 'large';
      }

      return 'large';
    },

    color(): string | null {
      return this.white ? '#efefef' : null;
    }
  }
});
